(() => {
  const initialiseSlider = (root) => {
    if (!root || root.dataset.gwSliderReady === 'true') return;

    const viewport = root.querySelector('[data-gw-slider-viewport]');
    const track = root.querySelector('[data-gw-slider-track]');
    const previousButton = root.querySelector('[data-gw-slider-prev]');
    const nextButton = root.querySelector('[data-gw-slider-next]');
    const status = root.querySelector('[data-gw-slider-status]');
    const controls = root.querySelector('[data-gw-slider-controls]');
    const items = Array.from(track?.children || []);

    if (!viewport || !track || !previousButton || !nextButton || !items.length) return;

    root.dataset.gwSliderReady = 'true';
    let frameRequest = null;

    const getMetrics = () => {
      const itemWidth = items[0].getBoundingClientRect().width;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const step = itemWidth + gap;
      const visible = step > 0
        ? Math.max(1, Math.round((viewport.clientWidth + gap) / step))
        : 1;
      const current = step > 0
        ? Math.max(0, Math.round(viewport.scrollLeft / step))
        : 0;
      const lastStart = Math.max(0, items.length - visible);

      return { step, visible, current: Math.min(current, lastStart), lastStart };
    };

    const update = () => {
      frameRequest = null;
      const { visible, current, lastStart } = getMetrics();
      const allVisible = items.length <= visible;

      if (controls) controls.hidden = allVisible;
      previousButton.disabled = allVisible || current <= 0;
      nextButton.disabled = allVisible || current >= lastStart;

      if (status) {
        if (allVisible) {
          status.textContent = '';
          status.hidden = true;
        } else {
          const firstVisible = current + 1;
          const lastVisible = Math.min(items.length, current + visible);
          status.textContent = `${firstVisible}–${lastVisible} / ${items.length}`;
          status.hidden = false;
        }
      }
    };

    const requestUpdate = () => {
      if (frameRequest) window.cancelAnimationFrame(frameRequest);
      frameRequest = window.requestAnimationFrame(update);
    };

    const move = (direction) => {
      const { step, visible, current, lastStart } = getMetrics();
      if (step <= 0 || items.length <= visible) return;

      const targetIndex = Math.max(
        0,
        Math.min(lastStart, current + (direction * visible))
      );
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      viewport.scrollTo({
        left: targetIndex * step,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    };

    previousButton.addEventListener('click', () => move(-1));
    nextButton.addEventListener('click', () => move(1));

    viewport.addEventListener('scroll', requestUpdate, { passive: true });

    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(requestUpdate);
      observer.observe(viewport);
      observer.observe(items[0]);
    } else {
      window.addEventListener('resize', requestUpdate);
    }

    update();
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll?.('[data-gw-surprise-slider]').forEach(initialiseSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
